import { api } from "~/api";
import type { TOffer } from "~/reducers/offer";

import type { TDoctorAgreement, TDoctorDocument, TDoctorOffer } from "./agreements-types";
import type { AgreementStatus } from "./documents-const";

const extendedApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAgreements: builder.query<TDoctorDocument[], void>({
      query: () => ({ url: "agreements" }),
    }),
    getPendingAgreementsCount: builder.query<{ count: number }, void>({
      query: () => ({ url: "agreements/pending_count" }),
      providesTags: ["Agreement"],
    }),
    getAgreement: builder.query<TDoctorAgreement, TDoctorAgreement["id"]>({
      query: (doctorAgreementId) => ({ url: `agreements/${doctorAgreementId}` }),
      providesTags: ["Agreement"],
    }),
    postAgreement: builder.mutation<
      void,
      { doctorAgreementId: TDoctorAgreement["id"]; status: AgreementStatus }
    >({
      query: ({ doctorAgreementId, ...data }) => ({
        url: `agreements/${doctorAgreementId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Agreement"],
    }),
    getPrivateDoctorOffer: builder.query<TOffer & TDoctorOffer, void>({
      query: () => ({ url: `offers/doctor/private?format=json` }),
    }),
  }),
});

export const {
  useGetAgreementsQuery,
  useGetAgreementQuery,
  usePostAgreementMutation,
  useGetPrivateDoctorOfferQuery,
} = extendedApi;

export function usePendingAgreementsCount(): number {
  const agreementsCountQuery = extendedApi.useGetPendingAgreementsCountQuery();
  return agreementsCountQuery.isSuccess ? agreementsCountQuery.data.count : 0;
}
